import { combineReducers } from "redux";
import moment from "moment";
import * as types from "./types";
import { types as licenseTypes } from "../license";

// TODO there are connects that are directly accessing state of info.user
const defaultState = {
  isFetching: false,
  hasFetched: false,
  creatingNewUser: false,
  mergingAccounts: false,
  isResettingPassword: false,
  emailVerificationRequesting: false,
  info: {}
};

// This is needed for legacy support because we may try
// to access labs that the user hasn't activated yet
const setupDefaultLabs = userInfo => {
  const gadgets = require("../../components/gadgets/gadgets"); // TODO I hate this
  if (userInfo && userInfo.labs) {
    gadgets.forEach(gadget => {
      const metadata = gadget.metadata();
      if (metadata.lab && !userInfo.labs[metadata.id]) {
        userInfo.labs[metadata.id] = {
          name: metadata.id,
          rating: 0,
          enabled: metadata.defaultEnabled && metadata.defaultEnabled()
        };
      }
    });
  }
  return userInfo;
};

const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case licenseTypes.UPDATE_LICENSE_SUCCESS:
      return {
        ...state,
        info: setupDefaultLabs({
          ...state.info,
          needsBookListUpdate: false,
          updatedBookListAt: moment()
            .utc()
            .format()
        })
      };
    case types.GET_USER_REQUEST:
    case types.SET_USER_INFO_REQUEST:
      return { ...state, isFetching: true };
    case types.SET_USER_INFO_FAILURE:
      return { ...state, isFetching: false };
    case types.GET_USER_SUCCESS:
    case types.SET_USER_INFO_SUCCESS:
    case types.CREATE_USER_SUCCESS:
    case types.MERGE_ACCOUNT_SUCCESS:
      return {
        ...state,
        info: setupDefaultLabs(action.userInfo),
        isFetching: false,
        hasFetched: true,
        creatingNewUser: false,
        mergingAccounts: false
      };
    case types.USER_SIGNED_OUT:
      return { ...defaultState, isFetching: false, hasFetched: true };
    case types.RESET_PASSWORD_REQUEST:
      return { ...state, resettingPassword: true };
    case types.RESET_PASSWORD_SUCCESS:
    case types.RESET_PASSWORD_FAILURE:
      return { ...state, resettingPassword: false };
    case types.CREATE_USER_REQUEST:
      return { ...state, creatingNewUser: true };
    case types.CREATE_USER_FAILURE:
      return { ...state, creatingNewUser: false };
    case types.MERGE_ACCOUNT_REQUEST:
      return { ...state, mergingAccounts: true };
    case types.MERGE_ACCOUNT_FAILURE:
      return { ...state, mergingAccounts: false };
    case types.EMAIL_EXISTS_REQUEST:
      return {
        ...state,
        emailStatus: {
          ...(state.emailStatus || {}),
          [action.email]: {
            isFetching: true
          }
        }
      };
    case types.EMAIL_EXISTS_SUCCESS:
      return {
        ...state,
        emailStatus: {
          ...(state.emailStatus || {}),
          [action.email]: {
            isFetching: false,
            exists: action.exists,
            approved: action.approved
          }
        }
      };
    case types.EMAIL_EXISTS_FAILURE:
      return {
        ...state,
        emailStatus: {
          ...(state.emailStatus || {}),
          [action.email]: {
            isFetching: false,
            error: action.error
          }
        }
      };
    case types.RESEND_ACTIVATION_EMAIL_REQUEST:
      return {
        ...state,
        activationStatus: {
          ...(state.activationStatus || {}),
          [action.email]: {
            isFetching: true
          }
        }
      };
    case types.RESEND_ACTIVATION_EMAIL_SUCCESS:
      return {
        ...state,
        activationStatus: {
          ...(state.activationStatus || {}),
          [action.email]: {
            isFetching: false,
            success: true
          }
        }
      };
    case types.RESEND_ACTIVATION_EMAIL_FAILURE:
      return {
        ...state,
        activationStatus: {
          ...(state.activationStatus || {}),
          [action.email]: {
            isFetching: false,
            error: action.error
          }
        }
      };
    case types.REQUEST_EMAIL_VERIFICATION_REQUEST:
      return {
        ...state,
        emailVerificationRequesting: true
      };
    case types.REQUEST_EMAIL_VERIFICATION_SUCCESS:
    case types.REQUEST_EMAIL_VERIFICATION_FAILURE:
      return {
        ...state,
        emailVerificationRequesting: false
      };
    default:
      return state;
  }
};

export default userReducer;
